import { render } from "./Berita.vue?vue&type=template&id=42d873ec"
import script from "./Berita.vue?vue&type=script&lang=js"
export * from "./Berita.vue?vue&type=script&lang=js"

import "./Berita.vue?vue&type=style&index=0&id=42d873ec&lang=css"
script.render = render

export default script